/* Fileiras arrastáveis (vitrines, recursos, depoimentos) e acordeões das seções portadas */
(function () {
  function initSlider(root) {
    if (root.dataset.fsReady) return;
    root.dataset.fsReady = '1';
    var track = root.querySelector('[data-fs-track]');
    if (!track) return;
    var prev = root.querySelector('[data-fs-prev]');
    var next = root.querySelector('[data-fs-next]');
    var buttons = root.querySelector('.fs-slider__buttons');
    function step() {
      var s = track.querySelector('.fs-slider__slide');
      if (!s) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 20;
      return s.getBoundingClientRect().width + gap;
    }
    function canScroll() { return track.scrollWidth - track.clientWidth > 4; }
    function update() {
      var can = canScroll();
      if (buttons) buttons.style.display = can ? '' : 'none';
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    // arrastar com o mouse
    var down = false, startX = 0, startScroll = 0, moved = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || !canScroll()) return;
      if (e.target.closest('video, video-media, button, input')) return;
      down = true; moved = 0; startX = e.clientX; startScroll = track.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.max(moved, Math.abs(dx));
      if (moved > 6) { track.classList.add('is-dragging'); track.scrollLeft = startScroll - dx; e.preventDefault(); }
    });
    window.addEventListener('pointerup', function () { if (down) { down = false; setTimeout(function () { track.classList.remove('is-dragging'); }, 0); } });
    track.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    update();
    setTimeout(update, 600);
  }
  function initAll(scope) {
    (scope || document).querySelectorAll('[data-fs-slider]').forEach(initSlider);
  }
  // botão "add" dos cards de complemento: adiciona ao carrinho e abre a gaveta do tema
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fs-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.dataset.fsAdd), quantity: 1 }] })
    }).then(function (r) { return r.json(); }).then(function () {
      b.disabled = false;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      var d = document.querySelector('cart-drawer');
      if (d && d.show) d.show(); else window.location.href = '/cart';
    }).catch(function () { b.disabled = false; window.location.href = '/cart'; });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
